module.exports = __webpack_public_path__ + "static/media/class_job_016.f30e9817.svg";